import React from "react";
import { useState } from "react";
import styled from 'styled-components';
import { boxes, texts } from "../../../constants";
import { ChannelBox } from "./ChannelBox";

const Wrapper = styled.div`
    width: 100%;
    height: 672px;
    background: ${({ theme }) => theme.colors.background};
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
`;

const Title = styled.div`
    font-size: ${({ theme }) => theme.fontSize.large};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    margin-bottom: 48px;
`;

const ContentWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 731px;
`;

export const ChooseScreen = () => {
    const [activeBox, setActiveBox] = useState('');

    const toggleActivateBox = (type: any) => {
        if (activeBox === type) {
            setActiveBox('')
        } else {
            setActiveBox(type)
        }
    } 

    return (
        <Wrapper>
            <Title>{texts.MODAL.STEP_1.SUBTITLE}</Title>
            <ContentWrapper>
                {boxes.map((data, index) => {
                    return (
                        <ChannelBox key={`${data.type}-${index}`} data={data} onClick={() => toggleActivateBox(data.type)} isActive={activeBox === data.type}/>
                    )
                })}
            </ContentWrapper>
        </Wrapper>
    )
}